import { Injectable } from '@angular/core';
import { NbComponentStatus, NbToastrService } from '@nebular/theme';

@Injectable({
    providedIn: 'root',
})
export class NotificationsService {
    private defaultErrorMessage =
        'Unknown server error.Please try again later.';
    private messageTitle = 'System';

    constructor(private toastrService: NbToastrService) {}

    showSuccessMessage(message: string | undefined) {
        this.show('success', message);
    }

    showWarning(message: string | undefined) {
        this.show('warning', message);
    }

    showError(message: string | undefined) {
        this.show('danger', message);
    }

    private show(status: NbComponentStatus, message: string | undefined) {
        this.toastrService.show(
            message ?? this.defaultErrorMessage,
            this.messageTitle,
            {
                status,
                icon:
                    status === 'danger'
                        ? 'close-circle-outline'
                        : status === 'success'
                        ? 'checkmark-outline'
                        : 'alert-triangle-outline',
            }
        );
    }
}
